import {Component, OnDestroy, OnInit} from '@angular/core';
import {DefaultPermissions} from '../../models/defaultPermissions.model';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import {PermissionsFacade} from '../../facade/permissions.facade';
import {tap} from 'rxjs/operators';
import {User} from '../../models/user.model';
import {combineLatest, Subscription} from 'rxjs';
import {Access} from '../../models/Acces.model';
import {UpdateAccessOnAsset} from '../../models/updateAccessOnAsset.model';
import {DeleteAccessComponent} from '../dialogs/delete-access/delete-access.component';
import {DeleteAccess} from '../../models/deleteAccess.model';
import {ChartModel} from '../../../../../dashboard/models/chart';
import {environment} from '../../../../../../../environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { UserModel } from '../../../../models/user.model';

@Component({
  selector: 'morva-chart-permission',
  templateUrl: './chart-permission.component.html',
  styleUrls: ['../styles.scss', './chart-permission.component.scss'],
})
export class ChartPermissionComponent implements OnInit, OnDestroy {
  totalPage: number;
  pageNumber: number;
  chart: Partial<ChartModel>;
  permissionGroupType = 'Chart';
  user: UserModel;
  users: User[] ;
  defaultRoles: any[] = [];
  defaultPermissions = new DefaultPermissions().filter(this.permissionGroupType);
  selectedRole: any;
  assetId: any;
  workspaceId: any;
  loading = false;
  isChartPermissionsUpdated: boolean;
  subscriptions =[];
  subscription: Subscription;
  sanitizedString: SafeHtml;
  helpURL = `${environment.api}/File/Download?path=058d03e3-9abd-409f-8ad2-4cfba8d189a2/` +
    'ApplicationFiles/b1cacb55-6d49-4a81-8b76-524fce18a976.pdf';
  constructor(protected dialogRef: NbDialogRef<any>,
              private dialogService: NbDialogService,
              private permissionsFacade: PermissionsFacade,
              private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.loading = true;
    this.assetId = this.chart.chartId;
    this.sanitizedString = this.sanitizer.bypassSecurityTrustHtml(this.chart?.name);
    this.permissionsFacade.updatePageNumber(1);
    this.loadUsersAndGroups();
    this.setSubscribers();
  }

  loadUsersAndGroups() {
    this.permissionsFacade.loadUsersAndUserGroups(this.permissionGroupType, this.workspaceId, this.assetId);
  }

  setSubscribers() {

    this.subscriptions.push(this.permissionsFacade.getUsers$().
    pipe(tap((users: User[]) => this.users = users)));

    this.subscriptions.push(this.permissionsFacade.getDefaultAccess$().
    pipe(tap(defaultRoles =>this.defaultRoles = defaultRoles)));

    this.subscriptions.push(this.permissionsFacade.getTotalPages$().
    pipe(tap((totalPage: number) => this.totalPage = totalPage)));

    this.subscriptions.push(this.permissionsFacade.getPageNumber$().
    pipe(tap(pageNumber => this.pageNumber = pageNumber)));

    combineLatest(this.subscriptions).subscribe(() => this.loading = false);

    this.subscription = this.permissionsFacade.getIsChartPermissionsUpdated$()
        .subscribe(isChartPermissionsUpdated => this.isChartPermissionsUpdated = isChartPermissionsUpdated);
  }

  changeRole(roleId: string, userIndex: number) {
    this.selectedRole = this.defaultRoles.find(role => role.id === roleId);
    const permissions =
      new DefaultPermissions().mapSpecificPermissions(this.selectedRole.permissions,this.permissionGroupType,false);
    this.permissionsFacade.updateUserPermissions(roleId, userIndex,permissions, true);
    const access = new Access(
      this.users[userIndex].id,
      this.users[userIndex].accessRecipientId,
      this.users[userIndex].accessRecipientType,
      false,
      true,
      roleId);
    const body = new UpdateAccessOnAsset(this.workspaceId, this.assetId, this.permissionGroupType, access);
    this.permissionsFacade.updateChart(body);
  }


  changePermission(isChecked, enName, userIndex): void {
    let permissionsSelected: any =
      new Map(JSON.parse(JSON.stringify(Array.from(this.users[userIndex].permissionsSelected))));
    permissionsSelected =  this.checkViewAccess(isChecked, enName, permissionsSelected);
    const permissions = this.mapPermissions(permissionsSelected);
    this.permissionsFacade.updateUserPermissions('', userIndex, permissionsSelected, false);
    const access = new Access(
      this.users[userIndex].id,
      this.users[userIndex].accessRecipientId,
      this.users[userIndex].accessRecipientType,
      false,
      false,
      permissions);
    const body = new UpdateAccessOnAsset(this.workspaceId, this.assetId,this.permissionGroupType , access);
    this.permissionsFacade.updateChart(body);
  }

  mapPermissions(selectedPermissions: Map<string,any>): number[] {
    const result: number[] = [];
    selectedPermissions.forEach(permission => {
      if (permission.isChecked) {
        result.push(permission.id);
      }
    });
    return result;
  }

  changePageNumber(pageNumber: number) {
    this.permissionsFacade.updatePageNumber(pageNumber);
    this.permissionsFacade.updateUsersPaginateState(this.permissionGroupType,this.workspaceId,this.assetId,pageNumber);
  }

  closeDialog() {
    this.dialogRef.close(this.isChartPermissionsUpdated);
    this.permissionsFacade.updatePageNumber(1);
  }

  openDeleteDialog(user: User) {
    const accessType = this.permissionGroupType;
    this.dialogService.open(DeleteAccessComponent, {context: {user,accessType}}).
    onClose.subscribe((isDelete) => {
      if (isDelete) {
        const body: DeleteAccess = {
          workspaceId: this.workspaceId,
          assetId: this.assetId,
          accessId: user.id,
          accessRecipientId: user.accessRecipientId,
          assetType: this.permissionGroupType,
          userType: user.accessRecipientType,
        };
        this.permissionsFacade.deleteUserAccess(body);
        this.isChartPermissionsUpdated = true;
      }
    });
  }
  
  checkViewAccess(isChecked: boolean, enName: string, permissions: any): any {
    if(enName !== 'View' && isChecked) {
      permissions.get('View').isChecked = isChecked;
      permissions.get(enName).isChecked = isChecked;
    } else if (enName !== 'View' && !isChecked) {
      permissions.get(enName).isChecked = isChecked;
    } else if (enName === 'View' && isChecked) {
      permissions.get('View').isChecked = isChecked;
    } else if (enName === 'View' && !isChecked) {
      permissions = new DefaultPermissions().filter(this.permissionGroupType);
    }
    return permissions;
  }

  
  isUserDisabled(user: User): boolean {
    if(user.accessRecipientType=="Solo")
    {return user.accessRecipientId === this.user.id;}
    if(user.accessRecipientType=="Group")
    {return user.userGroup?.users.some(userId => userId === this.user.id)}
    return false;
  }
  ngOnDestroy(): void {
    this.permissionsFacade.updateIsChartPermissionsUpdated(false);
    this.subscription.unsubscribe();
  }
}
